import { render, staticRenderFns } from "./ResetApply.vue?vue&type=template&id=2b512493&"
import script from "./ResetApply.vue?vue&type=script&lang=js&"
export * from "./ResetApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports